(function () {
  var config = window.pcmFaqSearch || {};
  var endpoint = config.rest_url || '';
  var minLength = parseInt(config.min_length || 2, 10);

  if (!endpoint) {
    return;
  }

  function debounce(callback, delay) {
    var timer = null;

    return function () {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        callback.apply(null, args);
      }, delay);
    };
  }

  function clearElement(element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  function setStatus(statusElement, message) {
    if (statusElement) {
      statusElement.textContent = message;
    }
  }

  function renderEmpty(resultsElement, message) {
    clearElement(resultsElement);

    var empty = document.createElement('p');
    empty.className = 'faq-search-results__empty';
    empty.textContent = message;
    resultsElement.appendChild(empty);
  }

  function renderResults(resultsElement, results) {
    clearElement(resultsElement);

    var list = document.createElement('ul');
    list.className = 'faq-search-results__list';

    results.forEach(function (result) {
      var item = document.createElement('li');
      item.className = 'faq-search-results__item';

      var link = document.createElement('a');
      link.className = 'faq-search-results__link';
      link.href = result.url;

      var title = document.createElement('span');
      title.className = 'faq-search-results__title';
      title.textContent = result.title;
      link.appendChild(title);

      var meta = document.createElement('span');
      meta.className = 'faq-search-results__meta';
      meta.textContent = result.category;
      link.appendChild(meta);

      if (result.excerpt) {
        var excerpt = document.createElement('span');
        excerpt.className = 'faq-search-results__excerpt';
        excerpt.textContent = result.excerpt;
        link.appendChild(excerpt);
      }

      item.appendChild(link);
      list.appendChild(item);
    });

    resultsElement.appendChild(list);
  }

  function initializeSearch(root) {
    var form = root.querySelector('.faq-search__form');
    var input = root.querySelector('[data-faq-search-input]');
    var status = root.querySelector('[data-faq-search-status]');
    var resultsElement = root.querySelector('[data-faq-search-results]');
    var requestController = null;

    if (!form || !input || !resultsElement) {
      return;
    }

    function search() {
      var query = input.value.trim();

      if (requestController) {
        requestController.abort();
      }

      if (query.length < minLength) {
        clearElement(resultsElement);
        setStatus(status, query.length ? 'Keep typing to search FAQs.' : 'Begin typing to search FAQs.');
        return;
      }

      requestController = new AbortController();
      setStatus(status, 'Searching FAQs...');

      var url = new URL(endpoint);
      url.searchParams.set('q', query);
      url.searchParams.set('limit', '12');

      window.fetch(url.toString(), {
        signal: requestController.signal,
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('FAQ search request failed.');
          }

          return response.json();
        })
        .then(function (data) {
          var results = Array.isArray(data.results) ? data.results : [];

          setStatus(
            status,
            results.length === 1
              ? '1 result for "' + query + '"'
              : results.length + ' results for "' + query + '"'
          );

          if (!results.length) {
            renderEmpty(resultsElement, 'No matching FAQs found. Try a broader search or browse by topic below.');
            return;
          }

          renderResults(resultsElement, results);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') {
            return;
          }

          setStatus(status, 'Search is unavailable right now.');
          renderEmpty(resultsElement, 'Search is unavailable right now. Browse by topic below.');
        });
    }

    var debouncedSearch = debounce(search, 250);

    input.addEventListener('input', debouncedSearch);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      search();
    });

    if (input.value.trim().length >= minLength && !resultsElement.children.length) {
      search();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq-search]').forEach(initializeSearch);
  });
})();
